import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import * as api from '../api/client'

/** Sticky top bar. Brand title left, nav right. Hidden on team views —
 * team members don't sign in, so there's nothing for them to see. */
export default function Header() {
  const user = useAuthStore((s) => s.user)
  const setUser = useAuthStore((s) => s.setUser)
  const navigate = useNavigate()
  const location = useLocation()

  if (location.pathname.startsWith('/team/')) return null

  async function handleLogout() {
    try { await api.logout() } catch { /* ignore — clear locally either way */ }
    setUser(null)
    navigate('/')
  }

  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="px-4 sm:px-6 h-12 flex items-center justify-between">
        <Link to="/" className="text-sm font-semibold text-brand-700 hover:underline">
          AI Transformation Flight Simulator
        </Link>
        {user && (
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/sessions" className="text-slate-700 hover:text-brand-700">
              My Sessions
            </Link>
            <span className="flex items-center gap-2 text-slate-600">
              {user.avatar_url && (
                <img
                  src={user.avatar_url}
                  alt=""
                  className="w-6 h-6 rounded-full"
                  referrerPolicy="no-referrer"
                />
              )}
              <span className="hidden sm:inline">
                {user.display_name || user.email}
              </span>
            </span>
            <button
              type="button"
              onClick={handleLogout}
              className="text-slate-500 hover:text-danger text-xs"
            >
              Sign out
            </button>
          </nav>
        )}
      </div>
    </header>
  )
}
